<template>
  <el-popover
    placement="bottom"
    trigger="hover"
    popper-class="test-info-popover"
    :width="291"
    show-arrow
  >
    <div class="container">
      <div class="flex title justify-between items-center">
        <div class="flex items-center">
          <p class="break-normal title-no-space-breaker">
            {{ name }}
          </p>
          <a v-if="item.weblink" :href="item.weblink" target="_blank" class="ml-1">
            <span class="material-icons-outlined insert-link-icon small-icon">
              insert_link
            </span>
          </a>
        </div>
        <p v-if="item.price" class="mr-3">{{ currency.symbol + item.price.toFixed(2) }}</p>
      </div>
      <hr v-if="biomarkers.length > 0" class="divider">
      <div
        v-if="biomarkers.length > 0"
        class="flex flex-row justify-between mt-2 mb-1"
      >
        <p class="biomarkers">Biomarkers:</p>
        <button
          class="mr-3 show-all-btn"
          @click="isShowAll = !isShowAll"
        >
          Show all {{ biomarkers.length }} markers
          <span class="material-icons-outlined arrow-icon">
            {{ isShowAll ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
          </span>
        </button>
      </div>
      <div v-show="isShowAll" class="mt-1 ml-2">
        <div class="grid grid-cols-3 gap-1">
          <p v-for="marker in biomarkers" :key="marker">
            {{ marker }}
          </p>
        </div>
      </div>
    </div>
    <hr class="divider-2">
    <div class="grid grid-cols-2 ml-3.5">
      <div>
        <p class="font-bold">Sample type:</p>
        <div class="flex flex-wrap gap-x-1">
          <div
            v-for="typeName in sampleTypeSet"
            :key="typeName"
          >
            <TestSampleTypeTag
                v-if="sampleTypeSet.size <= 1"
                :type-name="typeName"
                style="min-width: 51px;"
              />
              <TestSampleTypeTag
                v-else
                :type-name="getAbbreviation(typeName)"
                style="min-width: 30px;"
              />
          </div>
        </div>
      </div>
      <div v-if="isPhlebotomy">
        <p class="font-bold">Phlebotomy:</p>
        <p class="required mt-1">{{ phlebotomyText }}</p>
      </div>
    </div>
    <hr class="divider-2">
    <div class="grid grid-cols-2 ml-3.5 mb-1.5">
      <div>
        <p class="font-bold">Avg. Processing Time:</p>
        <p class="mt-1">{{ item.processingTime }}</p>
      </div>
      <div>
        <p class="font-bold">Shipping Time:</p>
        <p class="mt-1">{{ item.shippingTime }}</p>
      </div>
    </div>
    <template v-slot:reference>
      <span class="material-icons-outlined info-icon">
        info
      </span>
    </template>
  </el-popover>
</template>

<script>
import TestSampleTypeTag from "./TestSampleTypeTag.vue";
import { processNameAbbreviation } from "@/utils/va-order-test/index.js";
import { mapState } from "vuex";

export default {
  components: {
    TestSampleTypeTag
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    name: {
      type: String,
      default: ""
    },
    sampleTypeSet: {
      type: Set,
      default: null
    },
    biomarkers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isShowAll: false,
      processingTime: "",
    };
  },
  computed: {
    ...mapState(["currency"]),

    isPhlebotomy() {
      if (this.sampleTypeSet)
        return Array.from(this.sampleTypeSet).some(type => ["Serum", "EDTA", "TES", "Plasma"].includes(type));
      return false;
    },

    phlebotomyText() {
      if (this.sampleTypeSet) {
        if (Array.from(this.sampleTypeSet).some(type => ["DBS"].includes(type))){
          return "Optional";
        }
      }
      return "Requied"
    }
  },
  methods: {
    getAbbreviation(name) {
      return processNameAbbreviation(name);
    }
  }
};
</script>

<style scoped>
.container {
  margin: 12px 7px 0 14px;
  width: 268px;
  letter-spacing: 0.4px;
}

.title {
  font-weight: bold;
  font-size: 12px;
  margin-right: 12px;
}

.divider {
  box-sizing: border-box;
  height: 1px;
  width: 288px;
  border: 0.5px solid #999999;
  margin: 6px -8px 7px -13px;
}

.biomarkers {
  color: #ffffff;
  font-weight: bold;
}

.show-all-btn {
  color: #20A8C3;
  line-height: 11px;
}

.arrow-icon {
  color: #ffffff;
  font-size: 18px;
  height: 10px;
  position: absolute;
  margin-top: -3px;
}

.divider-2 {
  box-sizing: border-box;
  height: 1px;
  width: 277px;
  border: 0.5px solid #999999;
  margin: 6px;
}

.required {
  color: #f06539;
  line-height: 11px;
}

.info-icon {
  font-size: 20px;
}
.insert-link-icon {
  color: #3498DB;
  /* font-size: 14px; */
}

.title-no-space-breaker {
  max-width: 131px; /* prevent title name text overflow cause by no empty space */
  word-wrap: break-word;
}
</style>
